export enum S3GRole {
  User,
  Manager,
  Admin,
  SuperAdmin,
  ClientOnboarding,
}
